module.exports = __webpack_public_path__ + "static/media/img02_special_map.15899e72.png";